export const color = {
  Red: '#653FE1',
  Red2: '#903739',
  Purple: '#a91bb3',
  Dark_Purple: '#901799',
  Deep_Purple: '#2d082f',
  Blue: '#3352bb',
  Azul: '#06a6ed',
  FigmaBlue: '#0D99FF',
  Green: '#05b246',
  Yellow: '#fcbf00',
  Orange: '#ff3905',
  Gray: '#557f8c',
  Pink: '#EDC0DE',
  Light_menu_BG: '#253042',
  Light_Green: '#86c28d',
  Dark_Grey: '#302E33',
  Light_Grey: '#666',
  White: '#EAEAEA',
  White2: '#fff',
  Super_Light_Transparent: '#DDF2',
  Yambo_Green: '#16745D',
  Yambo_Green_Dark: '#0B4836',
  Yambo_Green_Stroke: '#45A08A',
  Yambo_Purple: '#653FE1',
  Yambo_Purple_Dark: '#352074',
  Yambo_Purple_Stroke: '#8C6DEF',
  Yambo_Blue: '#2C57F0',
  Yambo_Blue_Dark: '#183C9B',
  Yambo_Blue_Stroke: '#5A82E8',
  Yambo_Orange: '#E54A19',
  Yambo_Orange_Dark: '#C53111',
  Yambo_Orange_Stroke: '#EA8362',
  Yambo_Black: '#312f37',
  Yambo_Black_Dark: '#222127',
  Yambo_Black_Stroke: '#65616b',
  Yambo_CTA_BG: '#F2F0F8',
  Yambo_Idle_Icon: '#4E4B55',
  Yambo_White_BG: '#E5E3EB',
  Yambo_Text_On_White: '#1C1B1F',
  Yambo_Red_Stroke: '#ff8080',
  Icon_Button_Active: '#653FE1',
  Icon_Button_Hover: '#000',

  // New Colors - See Figma for reference

  // Black Opaque Colors
  Black100: 'rgba(14, 14, 19, 1)',
  Black92: 'rgba(33, 33, 38, 1)',
  Black88: 'rgba(43, 43, 47, 1)',
  Black84: 'rgba(53, 53, 57, 1)',
  Black64: 'rgba(101, 101, 104, 1)',
  Black40: 'rgba(159, 159, 161, 1)',
  Black16: 'rgba(216, 216, 217, 1)',
  Black08: 'rgba(236, 236, 236, 1)',
  Black04: 'rgba(245, 245, 246, 1)',

  // Black Transparent Colors
  Black92_T: 'rgba(14, 14, 19, 0.92)',
  Black84_T: 'rgba(14, 14, 19, 0.84)',
  Black64_T: 'rgba(14, 14, 19, 0.64)',
  Black40_T: 'rgba(14, 14, 19, 0.4)',
  Black16_T: 'rgba(14, 14, 19, 0.16)',
  Black08_T: 'rgba(14, 14, 19, 0.08)',
  Black04_T: 'rgba(14, 14, 19, 0.04)',

  // White Colors
  White100: 'rgba(255, 255, 255, 1)',
  // Opaque values from the Figma "Color mapping to white" table.
  // The table provides hex values for these rows; names mirror the legacy ramp positions.
  // Transparent white alpha tokens use the `_T` suffix below.
  White64: '#AFAFB1',
  White40: '#7A7A7D',
  White16: '#454549',
  White80_T: 'rgba(255, 255, 255, 0.8)',
  White64_T: 'rgba(255, 255, 255, 0.64)',
  White40_T: 'rgba(255, 255, 255, 0.4)',
  White16_T: 'rgba(255, 255, 255, 0.16)',
  White08_T: 'rgba(255, 255, 255, 0.08)',
  White04_T: 'rgba(255, 255, 255, 0.04)',

  // Yellow Colors
  Yellow100: 'rgba(247, 255, 168, 1)',
  Yellow64: 'rgba(250, 255, 199, 1)',
  Yellow40: 'rgba(252, 255, 220, 1)',
  Yellow16: 'rgba(254, 255, 241, 1)',
  Yellow_Secondary: 'rgba(220, 220, 194, 1)',

  // Yellow Transparent Colors
  Yellow16_T: 'rgba(247, 255, 168, 0.16)',
  Yellow8_T: 'rgba(247, 255, 168, 0.08)',
  Yellow64_T: 'rgba(247, 255, 168, 0.64)',

  // Purple Colors
  Purple100: 'rgba(160, 71, 233, 1)',
  Purple80_T: 'rgba(160, 71, 233, 0.8)',
  Purple64_T: 'rgba(160, 71, 233, 0.64)',
  Purple40_T: 'rgba(160, 71, 233, 0.4)',
  Purple24_T: 'rgba(160, 71, 233, 0.24)',
  Purple16_T: 'rgba(160, 71, 233, 0.16)',

  // Cool Grey Colors
  CoolGrey100: 'rgba(227, 232, 236, 1)',
  CoolGrey80_T: 'rgba(227, 232, 236, 0.8)',
  CoolGrey64_T: 'rgba(227, 232, 236, 0.64)',
  CoolGrey40_T: 'rgba(227, 232, 236, 0.4)',
  CoolGrey24_T: 'rgba(227, 232, 236, 0.24)',
  CoolGrey16_T: 'rgba(227, 232, 236, 0.16)',

  Weavy_Menu_Border: 'rgba(240, 240, 229, 0.08)',

  Weavy_Error: 'rgb(232, 85, 85)',
  Weavy_Error_80_T: 'rgba(232, 85, 85, 0.8)',
  Weavy_Error_64_T: 'rgba(232, 85, 85, 0.64)',
  Weavy_Error_40_T: 'rgba(232, 85, 85, 0.4)',
  Weavy_Error_16_T: 'rgba(232, 85, 85, 0.16)',
  Weavy_Error_08_T: 'rgba(232, 85, 85, 0.08)',
  Weavy_Error_08: 'rgb(32, 20, 25)',

  Active_Tag_BG: '#D0D0FF',
  Active_Tag_Text: '#415FE0',
  Invited_Tag_Text: '#A64A10',

  DataType_Text: '#F1A0FA',
  DataType_Image: '#6EDDB3',
  DataType_Video: '#EF9092',
  DataType_3D: '#6E6CEC',
  DataType_Mask: '#C1DD6E',
  DataType_Audio: '#4452F2',
  DataType_Lora: '#BB68FF',
  DataType_Seed: '#E77E3E',
  DataType_Boolean: '#10A535',
  DataType_Number: '#ACE3B2',
  DataType_Array: '#68B0FF',
  DataType_KlingElement: '#FACDA0',
  DataType_Keyframe: '#FAB815',
  DataType_Any: 'rgba(254, 255, 241, 1)',

  TextSelection: '#507FAC',

  /** Dev-only label (e.g. "Development" toggle in workflow header) */
  Dev_Label: '#ff0000',

  TrueValueGreen: 'rgb(16, 165, 53)',
  TrueValueGreen_16: 'rgba(16, 165, 53, 0.16)',
  FalseValueRed: 'rgb(232, 85, 85)',
  FalseValueRed_16: 'rgba(232, 85, 85, 0.16)',
};

export const EL_COLORS = {
  BoxBorder: color.White04_T,
  DividerBorder: color.White08_T,
};

export const colorMap = new Map(Object.entries(color));
